import { FC } from "react";
import { Controller } from "react-hook-form";
import { FormFeedback, Input } from "reactstrap";
import { SelectBoxProps } from "./SelectBox.constant";
import React from "react";

const SelectBox: FC<SelectBoxProps> = ({
  control,
  name,
  className,
  options,
  defaultValue,
  onChangeHandler,
  error,
}) => {
  return (
    <React.Fragment>
      <>
        {control ? (
          <Controller
            control={control}
            name={name}
            defaultValue={defaultValue}
            render={({ field }) => {
              return (
                <>
                  <select
                    defaultValue={defaultValue}
                    {...field}
                    onChange={(e) => {
                      field.onChange(e.currentTarget.value);
                      onChangeHandler && onChangeHandler(e);
                    }}
                    className={className}
                  >
                    {options.map((option) => {
                      return (
                        <option value={option.value} key={option.key}>
                          {option.key}
                        </option>
                      );
                    })}
                  </select>
                </>
              );
            }}
          />
        ) : (
          <select
            defaultValue={defaultValue}
            onChange={(e) => onChangeHandler && onChangeHandler(e)}
            className={className}
          >
            {options.map((option) => {
              return (
                <option value={option.value} key={option.key}>
                  {option.key}
                </option>
              );
            })}
          </select>
        )}
      </>
    </React.Fragment>
  );
};

export default SelectBox;
